"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkifyString = void 0;
var preact_1 = require("preact");
var LinkifyIt = require("linkify-it");
var default_component_renderer_1 = require("./decorators/default-component-renderer");
var LinkifyString = /** @class */ (function (_super) {
    __extends(LinkifyString, _super);
    function LinkifyString() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._linkify = new LinkifyIt();
        return _this;
    }
    LinkifyString.prototype._parseString = function (inputString) {
        var _this = this;
        if ((inputString || '').trim().length === 0) {
            return '';
        }
        var matches = this._linkify.match(inputString);
        if (!matches) {
            return inputString;
        }
        var elements = [];
        var lastIndex = 0;
        matches.forEach(function (match, i) {
            // Push preceding text if there is any
            if (match.index > lastIndex) {
                elements.push(inputString.substring(lastIndex, match.index));
            }
            var decoratedHref = match.url;
            var decoratedText = match.text;
            var decoratedComponent = _this.props.componentRenderer(decoratedHref, decoratedText, i);
            elements.push(decoratedComponent);
            lastIndex = match.lastIndex;
        });
        // Push remaining text if there is any
        if (inputString.length > lastIndex) {
            elements.push(inputString.substring(lastIndex));
        }
        return elements.length === 1 ? elements[0] : elements;
    };
    LinkifyString.prototype.render = function () {
        return (0, preact_1.h)("span", null, this._parseString(this.props.text));
    };
    LinkifyString.defaultProps = {
        componentRenderer: default_component_renderer_1.default,
    };
    return LinkifyString;
}(preact_1.Component));
exports.LinkifyString = LinkifyString;
//# sourceMappingURL=linkify-string.js.map